export default __webpack_public_path__ + "locales/es.dd493ddc29ae467a9bb452b4096e0402.json";